export default "__VITE_ASSET__BEZPHYNt__"